class ProgressBar extends PIXI.Container {
	public lastShot: number = -1;
	public shots: Array<Shot> = [];
	public prevShotCell: Cell = null;

	panel: PIXI.Sprite;
	bar: PIXI.Sprite;
	hpBarProgress: number = -1;

	public constructor() {
		super();

		this.panel = new PIXI.Sprite(Assets.ui.panel_hp);
		centerFrickingSprite(this.panel);
		this.panel.position.y++;
		this.addChild(this.panel);

		this.bar = new PIXI.Sprite(PIXI.Texture.WHITE);
		this.bar.tint = 0x11dd11;
		this.bar.position.set(-40, -4);
		this.bar.width = 80;
		this.bar.height = 8;
		this.addChild(this.bar);
	}

	setProgress(hp: number) {
		let prog = Math.round(hp * 80);
		if (prog < 0) prog = 0;
		if (prog > 80) prog = 80;
		this.bar.width = prog;
	}
}
